import Vue from 'vue'
import apiList from '@/service/apiList'
import { Message } from 'element-ui'
/* eslint-disable no-undef */
const cbhost = cbhostname

// 获取商城分类
function getMallBrandList () {
  let params = {
    rg_id: 'web',
    rg_ver: '9999'
  }
  return new Promise((resolve) => {
    Vue.prototype.$api.post(cbhost + '/v0.2/brand/get_brand_all', params)
      .then(function (res) {
        let data = []
        for (let i of res.data.list) {
          for (let j of i.value) {
            data.push({
              name: j.name,
              banner: j.logo,
              id: j.brand_id
            })
          }
        }
        resolve(data)
      })
      .catch(function (err) {
        console.log(err)
      })
  })
}
// 获取我的分类
function getMyBrandList (params) {
  return new Promise((resolve) => {
    // console.log(params)
    Vue.prototype.$api.get(apiList.brandList, params)
      .then(function (res) {
        // console.log(res.data)
        resolve(res.data)
      })
      .catch(function (err) {
        console.log(err)
      })
  })
}
// 保存我的分类
function saveMyBrandList (params) {
  return new Promise((resolve) => {
    // console.log(params)
    Vue.prototype.$api.post(apiList.addBrand, params)
      .then(function (res) {
        if (res.message === 'Success') {
          Message.success('保存成功')
        }
        resolve(res.data)
      })
      .catch(function (err) {
        console.log(err)
      })
  })
}
export {getMyBrandList, saveMyBrandList, getMallBrandList}



// WEBPACK FOOTER //
// ./src/models/brandModel.js